'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const debounce = (fn, timeoutMs) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, timeoutMs);
  };
};

exports.debounce = debounce;
//# sourceMappingURL=debounce.cjs.js.map
